import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CartActions } from '@spartacus/cart/base/core';
import { Cart } from '@spartacus/cart/base/root';
import {
  LoggerService,
  tryNormalizeHttpError,
} from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {SavedCartActions} from "@spartacus/cart/saved-cart/core";
import {GONVARRI_UPDATE_CART, GonvarriUpdateCart} from "../actions/gonvarri-update-cart.action";
import {GonvarriCartConnector} from "../connectors/gonvarri-cart.connector";

@Injectable()
export class GonvarriSavedCartEffects {
  protected logger = inject(LoggerService);

  saveCart$: Observable<
    | SavedCartActions.SaveCartFail
    | SavedCartActions.SaveCartSuccess
    | SavedCartActions.SaveCart
    | CartActions.LoadCartSuccess
    | CartActions.ClearCartState
    | GonvarriUpdateCart
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(GONVARRI_UPDATE_CART),
      map((action: GonvarriUpdateCart) => action.payload),
      switchMap(({ userId, cartId, saveCartName, saveCartDescription, cloneCart }) => {
        return this.cartConnector
          .save(userId, cartId, saveCartName, saveCartDescription, cloneCart)
          .pipe(
            switchMap((savedCart: Cart) => {
              return [
                new CartActions.ClearCartState(),
                new CartActions.LoadCartSuccess({
                  userId,
                  cartId,
                  cart: savedCart,
                }),
                new SavedCartActions.SaveCartSuccess({
                  userId,
                  cartId,
                  saveCartName,
                  saveCartDescription,
                }),
              ];
            }),
            catchError((error: HttpErrorResponse) =>
              of(
                new SavedCartActions.SaveCartFail({
                  userId,
                  cartId,
                  saveCartName,
                  saveCartDescription,
                  error: tryNormalizeHttpError(error, this.logger),
                })
              )
            )
          );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private cartConnector: GonvarriCartConnector
  ) {}
}
